export default function BSDLogo({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="logo-accent" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="100%" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
      {/* Hexagonal network lines */}
      <g stroke="url(#logo-accent)" strokeWidth="1.5" fill="none" opacity="0.35">
        <line x1="32" y1="12" x2="48" y2="22" />
        <line x1="48" y1="22" x2="48" y2="42" />
        <line x1="48" y1="42" x2="32" y2="52" />
        <line x1="32" y1="52" x2="16" y2="42" />
        <line x1="16" y1="42" x2="16" y2="22" />
        <line x1="16" y1="22" x2="32" y2="12" />
        <line x1="32" y1="12" x2="32" y2="32" />
        <line x1="48" y1="22" x2="32" y2="32" />
        <line x1="16" y1="42" x2="32" y2="32" />
      </g>
      {/* Nodes */}
      <g fill="url(#logo-accent)">
        <circle cx="32" cy="12" r="4" />
        <circle cx="48" cy="22" r="3" />
        <circle cx="48" cy="42" r="3" />
        <circle cx="32" cy="52" r="3.5" />
        <circle cx="16" cy="42" r="3" />
        <circle cx="16" cy="22" r="3" />
        <circle cx="32" cy="32" r="5" opacity="0.9" />
      </g>
      <circle cx="32" cy="32" r="9" stroke="#06b6d4" strokeWidth="1" fill="none" opacity="0.25" />
    </svg>
  )
}
